import React from 'react';
import { IconButton } from '@fluentui/react/lib/Button';
import {
  DefaultPalette,
  Stack,
  IStackStyles,
  IStackTokens,
  IStackItemStyles,
  Persona,
  PersonaSize,
  useTheme,
} from '@fluentui/react';
import { IContextualMenuItem, ContextualMenu } from '@fluentui/react/lib/ContextualMenu';
import { Image, ImageFit } from '@fluentui/react/lib/Image';
import { useNavigate } from 'react-router-dom';
import SystemClient from '../../../system/SystemClient';
import './layoutStyles.css';
import MessageCourier from '../../../lib/MessageCourier';
import { LOGO_PATH, LOGO_DARK_PATH } from '../../../common/constants';
import { Usuario } from '../../../system/Usuario/Usuario';
// @ts-ignore
import useNavigatorOnline from 'use-navigator-online';
import { useId } from '@fluentui/react-hooks';
import { TooltipHost, ITooltipHostStyles } from '@fluentui/react/lib/Tooltip';
import { isLightTheme } from '../../../App';

const stackStyles: IStackStyles = {
  root: {
    // background: '#fff',
    width: '100%',
    height: '50px',
    padding: '0.5rem',
  },
};

const stackItemRoorStyles = {
  alignItems: 'center',
  display: 'flex',
  height: 30,
};

const stackItemStyles: IStackItemStyles = {
  root: {
    ...stackItemRoorStyles,
    justifyContent: 'start',
  },
};

const stackItemJustifyEndStyles: IStackItemStyles = {
  root: {
    ...stackItemRoorStyles,
    justifyContent: 'end',
  },
};

const stackTokens: IStackTokens = {
  childrenGap: 5,
  // padding: 10,
};

interface IHeaderProps {
  onMenuButtonClick: () => void;
  system: SystemClient;
  courier: MessageCourier;
  changeBlockUI: (v: boolean) => void;
  user?: Usuario;
}

const signOutKey = 'signOut';
const myPanelKey = 'myPanel';
const openNotificationsKey = 'openNotifications';
const openPendingActivities = 'openPendingActivities';

const Header: React.FC<IHeaderProps> = (props) => {
  const tooltipId = useId('tooltip');

  const personaRef = React.useRef(null);
  const [showContextualMenu, setShowContextualMenu] = React.useState(false);
  const [showNotificationMenu, setShowNotificationMenu] = React.useState(false);
  const [searching, setSearching] = React.useState(false);

  const [showDialog, setShowDialog] = React.useState(false);
  const { isOnline } = useNavigatorOnline();
  const onHideContextualMenu = () => {
    setShowContextualMenu(false);
    setShowNotificationMenu(false);
  };
  const onShowContextualMenu = () => setShowContextualMenu(true);
  const onShowNotificationMenu = () => setShowNotificationMenu(true);

  const navigate = useNavigate();

  const MINUTE_MS = 120000;
  // const MINUTE_MS = 120000;

  const menuItems: IContextualMenuItem[] = React.useMemo(
    () => [
      // { key: myPanelKey, iconProps: { iconName: 'AccountManagement' }, text: 'Mi Perfil' },
      { key: signOutKey, iconProps: { iconName: 'SignOut' }, text: 'Cerrar sesión' },
    ],
    []
  );

  const onClickItem = async (item: IContextualMenuItem | undefined) => {
    if (item) {
      if (item.key === signOutKey) {
        await props.system.logout();
      }
    }
  };

  const onSearchIconClick = () => setSearching(true);
  const onCancelSearchIconClick = () => setSearching(false);
  const theme = useTheme()
  return (
    <Stack horizontal styles={stackStyles} tokens={stackTokens}>
      <React.Fragment>
        <Stack.Item grow={1} styles={stackItemStyles}>
          <IconButton
            iconProps={{
              iconName: 'GlobalNavButton',
              styles: { root: { color: DefaultPalette.themeLight } },
            }}
            title={'Menú'}
            ariaLabel="Menú"
            onClick={props.onMenuButtonClick}
            className="ms-hiddenLgUp"
          />
          <Image
            imageFit={ImageFit.contain}
            width={130}
            src={isLightTheme(theme) ? LOGO_PATH : LOGO_DARK_PATH}
          />
        </Stack.Item>
        <Stack.Item grow={4} styles={stackItemStyles}></Stack.Item>
        <Stack.Item grow={1} styles={stackItemJustifyEndStyles}>
          <div>
            <TooltipHost
              content={isOnline ? 'Tenes conexión' : 'No tenes conexión'}
              id={tooltipId}
              calloutProps={{ gapSpace: 0 }}
              styles={{ root: { display: 'inline-block' } }}
            >
              {isOnline ? (
                <IconButton
                  aria-describedby={tooltipId}
                  iconProps={{ iconName: 'InternetSharing' }}
                  ariaLabel=""
                  styles={{ root: { marginRight: '1rem', color: isOnline ? '#00c900' : 'red' } }}
                  onClick={() => {}}
                />
              ) : (
                <IconButton
                  aria-describedby={tooltipId}
                  iconProps={{ iconName: 'InternetSharing' }}
                  ariaLabel=""
                  styles={{ root: { marginRight: '1rem', color: isOnline ? '#00c900' : 'red' } }}
                  onClick={() => {}}
                  onRenderIcon={() => (
                    <div
                      className="blinking-icon"
                      style={{
                        height: 15,
                        width: 15,
                        borderRadius: 10,
                        background: 'red',
                      }}
                    ></div>
                  )}
                />
              )}
            </TooltipHost>
          </div>

          <div style={{ cursor: 'pointer' }}>
            <Persona
              onRenderPrimaryText={() => (
                <div>
                  <div>{props.user ? props.user.getNombre() : 'Sin conexión'}</div>
                  <div style={{ fontSize: 10 }}>{props.user ? props.user.getBreadcrumb() : ''}</div>
                </div>
              )}
              // secondaryText={props.user.getBreadcrumb()}
              text={props.user ? props.user.getNombre() : ''}
              ref={personaRef}
              size={PersonaSize.size32}
              title={props.user ? props.user.getNombre() : ''}
              onClick={onShowContextualMenu}
            />
          </div>

          <ContextualMenu
            items={menuItems}
            hidden={!showContextualMenu}
            target={personaRef}
            onItemClick={(e, item) => {
              onClickItem(item);
            }}
            onDismiss={onHideContextualMenu}
          />
        </Stack.Item>
      </React.Fragment>
    </Stack>
  );
};

export default Header;
